<ng-container *transloco="let t; read 'home.calculator'" [formGroup]="formGroup">
  <div class="text-blue1 text-2xl my-4 pb-2 text-center border-b border-sun-yellow" *ngIf="!advanced">
    {{ t('site_data.title') }}
  </div>
  <psc-select
    [hidden]="!advanced"
    formControlName="site_data_type"
    [label]="t('site_data.type_of_values')"
    [options]="siteDataTypeOptions"
    [isDisabled]="!([UserRole.ROLE_BUSINESS, UserRole.ROLE_BUSINESS_PLUS] | userHasRole)"
    [infoText]="t('site_data.info')"></psc-select>
  <div *ngIf="!([UserRole.ROLE_BUSINESS, UserRole.ROLE_BUSINESS_PLUS] | userHasRole) && advanced"
       class="text-sm text-gray-600 -mt-4">
    *{{ t('only_business_can_select') }}
  </div>

  <ng-container
    *ngIf="!([UserRole.ROLE_BUSINESS, UserRole.ROLE_BUSINESS_PLUS] | userHasRole) ||
    (formGroup.controls['site_data_type'] &&
    (formGroup.controls['site_data_type'].value === SiteDataInputType.NREL || formGroup.controls['site_data_type'].value === SiteDataInputType.PVGIS))">
    <psc-range
      @inOutAnimation
      formControlName="tilt"
      [label]="t('tilt.title')"
      [infoText]="t('tilt.info')"
      [stepLabels]="roofTiltValues"
      [min]="0"
      [max]="45"
      [step]="1"></psc-range>

    <!-- t(home.calculator.azimuth.values.N, home.calculator.azimuth.values.NW, home.calculator.azimuth.values.W, home.calculator.azimuth.values.SW) -->
    <!-- t(home.calculator.azimuth.values.S, home.calculator.azimuth.values.SE, home.calculator.azimuth.values.E, home.calculator.azimuth.values.NE, home.calculator.azimuth.values.N) -->
    <div class="flex">
      <psc-orientation-pointer
        @inOutAnimation
        *ngIf="!advanced"
        [orientation]="formGroup.controls['azimuth'].value"></psc-orientation-pointer>
      <psc-range
        class="flex-1"
        @inOutAnimation
        formControlName="azimuth"
        [label]="t('azimuth.title')"
        [infoText]="t('azimuth.info')"
        [stepLabels]="roofAzimuthValues | translateStringArray:t:'azimuth.values'"
        [min]="0"
        [max]="360"
        [step]="1"></psc-range>
    </div>

    <psc-input
      @inOutAnimation
      formControlName="area"
      [label]="t('area.title')"
      [infoText]="t('area.info')"
      ngDefaultControl
      prefix="m2"
      type="number"></psc-input>
  </ng-container>
  <ng-container
    *ngIf="(formGroup.controls['site_data_type']?.value === SiteDataInputType.PVSOL || formGroup.controls['site_data_type']?.value === SiteDataInputType.PVSYS)">

    <psc-file-input
      @inOutAnimation
      formControlName="site_data_file"
      [label]="t('site_data_file.title')"
      [infoText]="t('site_data_file.info')"
    ></psc-file-input>

    <psc-input
      @inOutAnimation
      formControlName="system_capacity"
      [label]="t('system_capacity.title')"
      [infoText]="t('system_capacity.info')"
      ngDefaultControl
      prefix="kW"
      type="number"></psc-input>
  </ng-container>
</ng-container>
